"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _edit = _interopRequireDefault(require("@atlaskit/icon/core/edit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorEditIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.148 6.852a.5.5 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367z"/></svg>`
}, props, {
  newIcon: _edit.default
}));
EditorEditIcon.displayName = 'EditorEditIcon';
var _default = exports.default = EditorEditIcon;